import './paper.scss';

import Paper from './Paper';

export default Paper;
